"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInvestorInvitationStatus = void 0;
exports.EInvestorInvitationStatus = {
    sent: "sent",
    opened: "opened",
    in_progress: "in_progress",
    submitted: "submitted",
    revoked: "revoked",
};
